import Horaires from './Horaires.view';

export default Horaires;
